// extracted by mini-css-extract-plugin
module.exports = {"events-selector":"flows_events-selector__Ie3S5","event-item":"flows_event-item__2ZNs2"};